import { JsonEditor } from 'json-edit-react'
import React, { useState } from 'react'
import { Box } from '@mui/material'
import { INode } from 'shared/types/tree'
import { NodeIdMap } from '../../../version_mapping/utility'
import {
  customText,
  searchFilterForTypes,
  useButtons,
  useIsCollapsed,
} from './utility'
import { noteNodeDef } from './NoteNode'
import { FilterTypes } from './FilterTypes'

type GenericJsonViewProps = {
  tree: INode
  selectedNodeId?: string
  idMap?: NodeIdMap
  nodeButtons?: {
    Element: React.FC
    onClick: (node: INode) => void
  }[]
}

const theme = {
  styles: {
    container: {
      fontFamily: 'roboto',
    },
    itemCount: { color: '#777777' },
  },
}

const filterableKeys = [
  'tree_id',
  'version',
  'id',
  'parent_id',
  'type',
  'body',
  'title',
  'leaves',
]

export function CurriculaTree({
  tree,
  nodeButtons,
  selectedNodeId,
  idMap,
}: GenericJsonViewProps) {
  const [filteredTypes, setFilteredTypes] = useState([
    'tree_id',
    'version',
    'id',
    'parent_id',
    'leaves',
    'type',
    'body',
  ])

  const buttons = useButtons(nodeButtons)
  const isCollapsed = useIsCollapsed(selectedNodeId, idMap)

  const onFilterChange = (t: string, filtered: boolean) => {
    setFilteredTypes((prev) => {
      if (filtered) {
        if (prev.includes(t)) return prev
        return [...prev, t]
      }
      return prev.filter((s) => s !== t)
    })
  }

  return (
    <Box display="flex">
      <JsonEditor
        data={tree}
        collapse={isCollapsed}
        rootName={tree.title}
        restrictDelete={true}
        restrictAdd={true}
        restrictEdit={true}
        restrictDrag={true}
        restrictTypeSelection={true}
        stringTruncate={20}
        customText={customText}
        customButtons={buttons}
        searchFilter={searchFilterForTypes(filteredTypes)}
        theme={theme}
        customNodeDefinitions={[noteNodeDef]}
      />
      <FilterTypes
        allTypes={filterableKeys}
        filteredTypes={filteredTypes}
        onFilterChange={onFilterChange}
      />
    </Box>
  )
}
